
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"7","height":"12","viewBox":"0 0 16 28"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.215 27.188a2.806 2.806 0 000-3.893L6.217 14l8.998-9.3c1.047-1.076 1.047-2.82 0-3.89a2.647 2.647 0 00-3.81 0L.757 11.811C.168 12.414-.056 13.213.011 14c-.067.78.157 1.583.746 2.183l10.648 11.006a2.649 2.649 0 003.81 0"}})])
          )
        }
      }
    